import React from "react";
import "./CSS/footer.css";
import { useThemeColors } from "../Context/Theme";
import { useNavigate, useLocation } from "react-router-dom";
import asidelogo from "../Images/aside-logo.png";
import fb from "../Images/ic-facebook.png";
import tiktok from "../Images/ic-tiktok.png";
import linkedin from "../Images/ic-linkedin.png";
import instagram from "../Images/ic-instagram.png";
import footer1 from "../Images/footer-img1.png";
import footer2 from "../Images/footer-img2.png";
import { isMobile } from "../global/helpers";
import { Box } from "@mui/material";

const Footer = ({ eventName, isAtAllEvents, icon, howitworksId, faqId }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { colorCode, textColor, headerColor, logo, fontFamily } = useThemeColors();
  const eventNameData = eventName
    ? eventName
    : sessionStorage.getItem("eventName");

  const handleContact = () => {
    if (isAtAllEvents) {
      navigate(`/events/contact`, { state: { isAtAllEvents: isAtAllEvents } });
    } else {
      navigate(`/events/${eventNameData}/contact`);
    }
  };

  const handleHome = () => {
    navigate(`/events/${eventNameData}`);
    window.scrollTo(0, 0);
  };

  const handleShop = () => {
    navigate(`/events/${eventNameData}/shop`, { state: { category: "all" } });
  };

  const handleScrollToSection = (sectionId) => {
    if (!isAtAllEvents) {
      navigate(`/events/${eventNameData}`);
    } else {
      navigate(`/events/`);
    }
    setTimeout(() => {
      const section = document.getElementById(sectionId);

      if (section) {
        // Scroll the section into view
        section.scrollIntoView({ behavior: "smooth", block: "start" });

        // Adjust scroll position by an offset (e.g., for fixed headers)
        const headerOffset = 150;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollBy({
          top: offsetPosition,
          behavior: "smooth",
        });
      } else {
        console.error("Section not found:", sectionId);
      }
    }, 500);
  };

  return (
    <div className="">
      <footer
        className="text-center text-lg-start text-muted"
        style={{ backgroundColor: "black" }}
      >
        <section className="">
          <>
            <div className="col-md-12 text-center text-md-start mt-4" style={{ fontFamily }}>
              <div className="row">
                {/* Company logo and description */}
                <div className="col-md-2 col-lg-2 col-xl-3 col-sm-12 mx-auto">
                  <h6 className="text-uppercase fw-bold mb-4">
                    <img
                      src={isAtAllEvents ? icon : asidelogo}
                      alt="Logo"
                      height={80}
                      width={150}
                    />
                  </h6>
                  <p
                    className="footer-text"
                    style={
                      isMobile()
                        ? { justifyContent: "center", fontFamily }
                        : { textAlign: "start", fontFamily }
                    }
                  >
                    You're Tailgate Ready with OrderThat
                  </p>
                </div>

                {/* Navigation Links */}
                <div className="col-md-1 col-lg-1 col-xl-1 mx-2 mb-4">
                  {!isAtAllEvents && (
                    <>
                      <div
                        className="d-flex mt-0"
                        style={isMobile() ? { justifyContent: "center" } : {}}
                      >
                        <p
                          className="item-text"
                          style={{
                            cursor: "pointer",
                            fontFamily
                          }}
                          onClick={() => handleHome()}
                        >
                          Home
                        </p>
                      </div>
                    </>
                  )}
                  <div
                    className="d-flex"
                    style={isMobile() ? { justifyContent: "center" } : {}}
                  >
                    <p
                      className={`item-text ${isAtAllEvents ? "" : "mt-2"}`}
                      style={{ cursor: "pointer", fontFamily }}
                      onClick={() =>
                        handleScrollToSection(
                          `${isAtAllEvents
                            ? "howItWorks"
                            : "how-it-works-section"
                          }`
                        )
                      }
                    >
                      How It Works
                    </p>
                  </div>

                  <div
                    className="d-flex"
                    style={isMobile() ? { justifyContent: "center" } : {}}
                  >
                    <p
                      className="item-text mt-2"
                      style={{ cursor: "pointer", fontFamily }}
                      onClick={() =>
                        handleScrollToSection(
                          `${isAtAllEvents ? "faqContainer" : "faq-section"}`
                        )
                      }
                    >
                      FAQ's
                    </p>
                  </div>
                </div>

                <div
                  className="col-md-1 col-lg-2 col-xl-1 mx-auto mb-4"
                  style={isMobile() ? {} : { width: "10%" }}
                >
                  {!isAtAllEvents && <div
                    className="d-flex"
                    style={isMobile() ? { justifyContent: "center" } : {}}
                  >
                    <p
                      className="item-text mt-0"
                      style={{
                        cursor: "pointer",
                        fontFamily
                      }}
                      onClick={() => handleShop()}
                    >
                      Popular Products
                    </p>
                  </div>}
                  <div
                    className={`d-flex ${isAtAllEvents ? "" : "mt-2"}`}
                    style={isMobile() ? { justifyContent: "center" } : {}}
                  >
                    <p
                      className="item-text"
                      style={{
                        cursor: "pointer",
                        fontFamily
                      }}
                      onClick={() => handleContact()}
                    >
                      Contact Us
                    </p>
                  </div>


                </div>

                <div
                  className="col-md-1 col-lg-2 col-xl-1 mx-auto mb-4"
                  style={
                    isMobile()
                      ? {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }
                      : { width: "10%" }
                  }
                >

                  <h6 className="link-text" style={{ fontFamily }}>Follow us</h6>
                  <div className="d-flex justify-content-start align-items-center mt-4">
                    <img
                      src={fb}
                      className="mr-4 social-icon"
                      style={{ width: "25px", height: "25px" }}
                      alt="Facebook"
                    />
                    <img
                      src={tiktok}
                      className="mr-4 social-icon"
                      style={{ width: "23px", height: "20px" }}
                      alt="Tiktok"
                    />
                    <img
                      src={instagram}
                      className="mr-4 social-icon"
                      style={{ width: "25px", height: "25px" }}
                      alt="Instagram"
                    />

                  </div>


                </div>

                {/* Download App Section */}
                <div
                  className="col-md-2 col-lg-2 col-xl-2 mx-auto download-app-section"
                  style={
                    isMobile()
                      ? {
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }
                      : {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",

                      }
                  }
                >
                  <h6 className="link-text" style={{ fontFamily }}>Download App</h6>
                  <img src={footer1} className="my-4" alt="App Store" />
                  <img src={footer2} alt="Google Play" />
                </div>
              </div>
            </div>
          </>
        </section>

        <div
          className="text-center p-2 col-md-12"
          style={{ backgroundColor: "#0E0E0E", color: "#929292" }}
        >
          <Box sx={{ display: "inline", mr: 2 }}>
            <Box
              component="span"
              onClick={() => {
                if (location.pathname === "/events/terms-and-conditions" || location.pathname === "/events/privacy-policy" || location.pathname === "/events/contact") {
                  window.scrollTo(0, 0);
                  navigate(`/events/`)
                } else {
                  navigate(`/events/`)
                  window.location.reload();
                }
              }
              }
              sx={{
                cursor: "pointer",
                color: "#929292",
                "&:hover": { color: "white" },
              }}
            >
              © {new Date().getFullYear()} OrderThat.com,{' '}
            </Box>
            <Box
              component="span"
              onClick={() => {
                if (location.pathname === "/events/terms-and-conditions" || location.pathname === `/events/${eventNameData}/terms-and-conditions`) {
                  window.scrollTo(0, 0);
                } else if (location.pathname === "/events" || location.pathname === "/events/" || location.pathname === "/events/contact" || location.pathname === "/events/privacy-policy") {
                  window.scrollTo(0, 0);
                  navigate("/events/terms-and-conditions", {
                    state: { isAtAllEvents: true },
                  });
                } else {
                  navigate(`/events/${eventNameData}/terms-and-conditions`, {
                    state: { isAtAllEvents: false },
                  });
                }
              }}
              sx={{
                cursor: "pointer",
                color: "#929292",
                "&:hover": { color: "white" },
              }}
            >
              Terms & Conditions
            </Box>
            ,{" "}
            <Box
              component="span"
              sx={{
                cursor: "pointer",
                color: "#929292",
                "&:hover": { color: "white" },
              }}
              onClick={() => {
                if (location.pathname === "events/privacy-policy" || location.pathname === `events/${eventNameData}/privacy-policy`) {
                  window.scrollTo(0, 0);
                } else if (location.pathname === "/events" || location.pathname === "/events/" || location.pathname === "/events/contact" || location.pathname === "/events/terms-and-conditions") {
                  window.scrollTo(0, 0);
                  navigate("/events/privacy-policy", {
                    state: { isAtAllEvents: true },
                  });
                } else {
                  navigate(`/events/${eventNameData}/privacy-policy`, {
                    state: { isAtAllEvents: false },
                  });
                }
              }}
            >
              Privacy Policy
            </Box>
          </Box>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
